module.exports = __webpack_public_path__ + "static/img/page3-img4.5102367.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/page3-img4.jpg
// module id = L13l
// module chunks = 0